import { render, staticRenderFns } from "./FeedExplitRadioGroup.vue?vue&type=template&id=8d66c5f4&scoped=true&"
import script from "./FeedExplitRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FeedExplitRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./FeedExplitRadioGroup.vue?vue&type=style&index=0&id=8d66c5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d66c5f4",
  null
  
)

export default component.exports